import React from "react";
import { Card, Table } from "antd";
import moment from "moment";

class PaymentLateArchive extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    columns = [
        {
            title: 'תאריך פתיחה',
            key: 'payment_late_since',
            align: 'right',
            render: (_, record) => moment(record.payment_late_since).format('DD/MM/YYYY')
        },
        {
            title: 'פירוט פתיחה',
            key: 'open_comment',
            align: 'right',
            render: (_, record) => <div style={{ ...style.comment }}>
                                        {record.open_comment}
                                    </div>
        },
        {
            title: 'תאריך סגירה',
            key: 'payed_at',
            align: 'right',
            render: (_, record) => moment(record.payed_at).format('DD/MM/YYYY')
        },
        {
            title: 'פירוט סגירה',
            key: 'close_comment',
            align: 'right',
            render: (_, record) => <div style={{ ...style.comment }}>
                                        {record.close_comment}
                                    </div>
        }
    ]

    render() {

        const { clientInfo: { payment_late_archive } } = this.props
        
        return(
            <Card
                title={"היסטוריית חיובים חוזרים"}
                headStyle={{ backgroundColor: '#dadce0' }}
            >

                <Table
                    columns={this.columns}
                    dataSource={payment_late_archive}
                    pagination={false}
                />

            </Card>
        )
    }
}


const style = {
    comment: {
        maxWidth: '170px',
        maxHeight: '150px',
        overflow: 'scroll',
        wordWrap: 'break-word',
        wordBreak: 'break-word'
    }
}

export default PaymentLateArchive